import Icon from "~/ui/Icon";
import useTranslation from "~/kernel/internationalization/useTranslation";
import ReviewCommentAuthor from "~/models/reviewComment/ReviewCommentAuthor";

type Props = { author: ReviewCommentAuthor };

export function ReviewAuthorBadge({ author }: Props) {
  const { tt } = useTranslation("reviewsSection");

  switch (author) {
    case ReviewCommentAuthor.Company:
      return (
        <span className="text-primary">
          <Icon name="circle-check" /> {tt("companyAuthor")}
        </span>
      );
    case ReviewCommentAuthor.User:
      return (
        <span className="text-slate-500">
          <Icon name="circle-check" /> {tt("customerAuthor")}
        </span>
      );
  }
}
